import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  output,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  IActualizacionFirmware,
  IFilter,
  IListado,
  IQueryParam,
} from 'modelos/src';
import { DialogService } from '../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { ListadosService } from '../../../auxiliares/servicios/listados.service';
import { FirmwareSirenasService } from '../../sirenas/firmware-sirenas.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../auxiliares/filtro-tabla/filtro-tabla/filtro-tabla.component';
declare type mainType = IActualizacionFirmware;

@Component({
  selector: 'app-listar-actualizaciones-fim',
  templateUrl: './listar-actualizaciones-fim.component.html',
  styleUrls: ['./listar-actualizaciones-fim.component.scss'],
  standalone: false,
})
export class ListarActualizacionesFirmComponent implements OnInit {
  private changeDetectorRef = inject(ChangeDetectorRef);
  private media = inject(MediaMatcher);
  private dialogService = inject(DialogService);
  private service = inject(FirmwareSirenasService);
  matDialog = inject(MatDialog);
  helper = inject(HelperService);
  private listadosService = inject(ListadosService);

  public search: IRegExpSearch = {
    fields: ['chipIdSirena'],
  };

  public etapa: IFiltroTabla = {
    elementos: [
      {
        nombre: '1- Enviando Mensaje a Sirena',
        _id: [
          { etapa: 'Enviado evento ACTUALIZAR_FIRMWARE (CRON)' },
          { etapa: 'Enviado evento ACTUALIZAR_FIRMWARE (MANUAL)' },
        ],
      },
      {
        nombre: '2- Enviando archivo a la sirena',
        _id: [{ etapa: 'Enviando archivo a la sirena' }],
      },
      {
        nombre: '3- Actualización correcta',
        _id: [{ etapa: 'Actualización correcta.' }],
      },
      {
        nombre: '4- Error de actualización',
        _id: [{ etapa: 'Error de actualización.' }],
      },
    ],
    filter: {
      field: '$or',
    },
    label: 'Etapa',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'select',
  };

  @Input() loading?: boolean;
  readonly loadingChange = output<boolean>();

  public columnas = [
    'fecha',
    'chipIdSirena',
    'firmwareActual',
    'firmwareNuevo',
    'etapa',
  ];
  public nombreColumnas = [
    'Fecha',
    'ChipId',
    'Firmware Actual',
    'Firmware Nuevo',
    'Etapa',
  ];
  public saveColumnas = 'tabla-firmware-sirenas';
  public dataSource = new MatTableDataSource<mainType>([]);
  private datos: mainType[] = [];
  // FILTRO BUSQUEDA Y PAGINACION
  public queryParams: IQueryParam = {
    page: 0,
    limit: +this.helper.pageSize,
    sort: '-fecha',
  };
  public totalCount = 0;
  // Listado Continuo
  private datos$?: Subscription;
  // Mobile query
  public mobileQuery: MediaQueryList;
  //

  constructor() {
    this.mobileQuery = this.media.matchMedia('(max-width: 599px)');
    this.mobileQuery.addEventListener('change', () =>
      this.changeDetectorRef.detectChanges(),
    );
  }

  private onLoadingChange(loading: boolean): void {
    this.loading = loading;
    this.loadingChange.emit(loading);
  }

  // ################################################################################
  // ################################# TABLA 1 ######################################
  // ################################################################################
  public pageEvent(event: PageEvent): void {
    this.helper.pageEvent(event);
    this.queryParams.page = event.pageIndex;
    this.queryParams.limit = event.pageSize;
    this.actualizar();
  }
  public sortChange(event: Sort): void {
    this.queryParams.sort =
      event.direction === 'asc' ? event.active : `-${event.active}`;
    this.actualizar();
  }
  public async cambioFiltro(filters: IFilter<any>) {
    this.onLoadingChange(true);
    this.queryParams = {
      page: 0,
      limit: this.queryParams.limit,
      sort: this.queryParams.sort,
      populate: this.queryParams.populate,
      select: this.queryParams.select,
      filter: JSON.stringify(filters),
    };
    await this.actualizar();
    this.onLoadingChange(false);
  }

  // ACCIONES
  public async eliminar(dato: mainType): Promise<void> {
    const confirm = await this.dialogService.confirm(
      'Confirme la acción',
      `¿Eliminar el firmware?`,
    );
    if (confirm) {
      try {
        this.onLoadingChange(true);
        await this.service.eliminar(dato._id!).pipe(take(1)).toPromise();
        this.helper.notifSuccess('Eliminación correcta');
        this.onLoadingChange(false);
      } catch (error) {
        console.error(error);
        this.helper.notifError(error);
        this.onLoadingChange(false);
      }
    }
  }

  // Listar
  public async actualizar(): Promise<void> {
    this.onLoadingChange(true);
    await this.listar();
    this.onLoadingChange(false);
  }

  private async listar(): Promise<void> {
    this.datos$?.unsubscribe();
    this.datos$ = this.listadosService
      .subscribe<
        IListado<IActualizacionFirmware>
      >('actualizacionFirmwares', this.queryParams)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.dataSource.data = data.datos;
        console.log(
          new Date().toLocaleString(),
          `listado de actualizacionesFirm`,
          data,
        );
      });
    await this.listadosService.getLastValue(
      'actualizacionFirmwares',
      this.queryParams,
    );
  }

  async ngOnInit(): Promise<void> {
    await this.actualizar();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', () =>
      this.changeDetectorRef.detectChanges(),
    );
    this.datos$?.unsubscribe();
  }
}
